import styles from "./styles.module.css";

const PostcodeResult: React.FC<{
	handleReset: () => void;
	children: React.ReactNode;
}> = ({ handleReset, children }) => {
	return (
		<>
			<div className="pt-3">{children}</div>
			<div className="col-12 col-md-9 pt-3 w-100 d-flex justify-content-center">
				<button
					type="button"
					name="button"
					className={`${styles.reset_postcode}`}
					title={"Change Postcode"}
					onClick={handleReset}
				>
					Change Postcode
				</button>
			</div>
		</>
	);
};

export default PostcodeResult;
